import * as moment from 'moment';
import {IChartColorService} from '../../utils/chart-color.service';
import {IDataValueApi} from '../../api/data-value-api.service';
import {ICurveSettingsApi} from '../../api/curve-settings-api.service';
import {IDischargeModelApi} from '../../api/discharge-model-api.service';
import {IDischargeModel, IStation} from '../../api/api.types';
import {IDischargeDataItem} from '../../discharge/data-list/discharge-data-list.controller';
import {IDischargeModelItem} from '../../discharge/model-list/model-list.controller';
import {IDischargeCurveSettings} from '../../discharge/curve.controller';
import hydrologicalYear from '../../utils/hydrological-year';
import {List, Set} from 'immutable';
import {IStationApi} from '../../api/station-api.service';
import {StateParams, StateService} from 'angular-ui-router';
import {IModelCreatorService} from '../../discharge/model-creator.service';
import {IImomoErrorService} from '../../error/error.service';

export interface IStationCurveStateParams extends StateParams {
  year:string;
  stationId:string;
}

export default class StationCurveController {
  static $inject = ['dischargeModelApi', 'dataValueApi', 'stationApi', 'curveSettingsApi',
    '$q', 'modelCreatorService', '$state',
    'chartColorService', '$scope', '$stateParams', 'imomoErrorService', '$rootScope'];

  isLoading:boolean;
  station:IStation;
  measuredDischargeDataItems:List<IDischargeDataItem>;
  dischargeModelItems:List<IDischargeModelItem>;
  dischargeModels:IDischargeModel[];
  minWaterLevel:number;
  maxWaterLevel:number;
  newModelOption:'deltaH'|'fitCurve';
  newModelName:string;
  newModelDate:Date;
  newModel:IDischargeModel;
  dischargeCurveSettings: IDischargeCurveSettings;
  deltaH:number;
  selectedDischargeModelId:number;
  selectedDischargeDataItems:Set<IDischargeDataItem>;
  year:number;
  stationId: number;

  constructor(private dischargeModelApi:IDischargeModelApi,
              private dataValueApi:IDataValueApi,
              private stationApi:IStationApi,
              private curveSettingsApi: ICurveSettingsApi,
              private $q:ng.IQService,
              private modelCreatorService:IModelCreatorService,
              private $state:StateService,
              private chartColorService:IChartColorService,
              private $scope:ng.IScope,
              private $stateParams:IStationCurveStateParams,
              private imomoErrorService: IImomoErrorService,
              private $rootScope: ng.IRootScopeService) {
    this.newModelOption = 'deltaH';
    this.selectedDischargeDataItems = Set<IDischargeDataItem>();

      this.parseYearFromParams(this.$stateParams);
    const stationId = Number.parseInt(this.$stateParams.stationId) || this.stationId;
    this.loadStationData(stationId);

    this.curveSettingsApi.getCurveSettings(stationId)
        .then(curveSettings => {

          if(curveSettings) {
            this.dischargeCurveSettings = curveSettings[0];
          }

    });

    this.$rootScope.$on('NEW_MODEL_UPDATED', () => {
      this.loadStationData(stationId);
    });
  }

  uiOnParamsChanged(newParams:any) {
    this.parseYearFromParams(newParams);
    this.loadStationData(this.station.id);
  }

  changeYear() {
    this.loadDischargeModels();
  }

  onSelectedItemsChange(selectedDischargeDataItems:List<IDischargeDataItem>) {
    this.selectedDischargeDataItems = Set(selectedDischargeDataItems);
  }

  onDischargeModelItemDelete(dischargeModelItem:IDischargeModelItem,
                             dischargeModelItems:List<IDischargeModelItem>) {

    let cachedDischargeModelItems = angular.copy(this.dischargeModelItems);
    const stationId = Number.parseInt(this.$stateParams.stationId) || this.stationId;

    if (dischargeModelItem.dischargeModel == this.newModel) {
      this.newModel = null;
    } else {
      this.isLoading = true;
      this.dischargeModelApi.deleteDischargeModel(
          dischargeModelItem.dischargeModel.id)
      .then(() => {
        this.dischargeModelItems = dischargeModelItems;
        const indexToDelete = this.dischargeModels
            .indexOf(dischargeModelItem.dischargeModel);
        this.dischargeModels.splice(indexToDelete, 1);
        if (this.selectedDischargeModelId == dischargeModelItem.dischargeModel.id) {
          this.selectedDischargeModelId = null;
        }
      })
      .catch((error) => {
        this.imomoErrorService.showErrorDetailsDialog(error.data.details);
        this.dischargeModelItems = cachedDischargeModelItems;
      })
      .finally(() => {
        this.isLoading = false;
        this.loadStationData(stationId);
        this.$rootScope.$broadcast('ALL_MODELS_UPDATED');
      });
    }
  }

  onChartBoundsChange(curveSettings: IDischargeCurveSettings, userChange: boolean) {
    this.minWaterLevel = curveSettings.minWaterLevel;
    this.maxWaterLevel = curveSettings.maxWaterLevel;

    if(userChange) {
      this.curveSettingsApi.createCurveSettings(curveSettings, this.station.id);
    }

  }

  isNewModelPossible() {
    if (this.newModelOption == 'deltaH') {
      return this.newModelName != null &&
          this.deltaH != null &&
          this.selectedDischargeModelId != null;
    } else {
      return this.selectedDischargeDataItems.size >= 2 &&
          this.newModelName != null;
    }
  }

  createNewModel() {
    if (this.newModel) {
      this.dischargeModelItems = this.dischargeModelItems.shift();
    }
    this.newModelDate = new Date();
    const selectedDischargeModel = this.dischargeModels.find(
        dischargeModel => dischargeModel.id == this.selectedDischargeModelId);
    this.newModel = this.modelCreatorService.createModel({
      name: this.newModelName,
      date: moment(this.newModelDate),
      creationMode: this.newModelOption,
      referenceModel: selectedDischargeModel,
      deltaH: this.deltaH,
      selectedDischargeDataItems: this.selectedDischargeDataItems.toList()
    });
    this.dischargeModelItems = this.dischargeModelItems.unshift({
      dischargeModel: this.newModel,
      enabled: true,
      colors: IChartColorService.BLACK_COLORS
    });
    this.clearNewModelForm();
  }

  saveNewModel() {
    this.isLoading = true;
    this.dischargeModelApi.createDischargeModel({
      modelName: this.newModel.modelName,
      paramA: this.newModel.paramA,
      paramB: this.newModel.paramB,
      paramC: this.newModel.paramC,
      paramDeltaLevel: this.newModel.paramDeltaLevel,
      validFrom: moment(this.newModelDate),
      siteId: this.station.id
    }).then(() => {
      this.newModel = null;
      this.clearNewModelForm();
      this.$rootScope.$broadcast('ALL_MODELS_UPDATED');
      return this.loadDischargeModels();
    }).finally(() => {
      this.isLoading = false;
    });
  }

  private clearNewModelForm() {
    this.newModelName = null;
    this.deltaH = null;
    this.selectedDischargeModelId = null;
    if (this.$scope['newModelForm']) {
      this.$scope['newModelForm'].$setPristine();
      this.$scope['newModelForm'].$setUntouched();
    }
  }

  private parseYearFromParams(params:{year:string}) {
    const parsedYear = Number.parseInt(params.year);
    this.year = Number.isNaN(parsedYear)
        ? this.year || moment().year() //hydrologicalYear(moment())
        : parsedYear;
  }

  private loadStationData(stationId:number) {
    this.isLoading = true;
    this.resetView();
    this.stationApi.getDischargeStation({stationId}).then(station => {
      this.station = station;
      this.$rootScope.$broadcast('STATION_LOADED', station);
      const dischargePromise = this.loadDischargeModels();
      const dataPromise = this.loadDischargeData();
      return this.$q.all([dischargePromise, dataPromise]);
    }).finally(() => {
      this.isLoading = false;
    });
  }

  private loadDischargeModels():ng.IPromise<void> {
    return this.dischargeModelApi
        .getDischargeModels(this.station.id, this.year)
        .then(dischargeModels => {
          this.dischargeModels = dischargeModels;
          this.dischargeModelItems = List(dischargeModels.map(
              (model, index) => {
                return {
                  dischargeModel: model,
                  enabled: false,
                  colors: this.chartColorService.getColors(index)
                };
              }));
          if (this.dischargeModelItems.size) {
            this.dischargeModelItems.first().enabled = true;
          }
        });
  }

  private loadDischargeData() {
    return this.dataValueApi.getDischargePairs(this.station.id,
        this.year)
        .then(dischargePairs => {
          this.measuredDischargeDataItems = List(dischargePairs
              .map(dischargeMeasurementPair => {
                return {
                  date: moment
                      .unix(dischargeMeasurementPair.waterLevel.localDateTime).utc(),
                  waterLevel: dischargeMeasurementPair.waterLevel.dataValue,
                  discharge: dischargeMeasurementPair.discharge.dataValue
                };
              }));
        });
  }

  private resetView() {
    this.dischargeModelItems = List<IDischargeModelItem>();
    this.measuredDischargeDataItems = List<IDischargeDataItem>();
    this.dischargeModels = [];
    this.clearNewModelForm();
    this.newModel = null;
  }
}



/** WEBPACK FOOTER **
 ** ./app/station/curve/curve.controller.ts
 **/